import moment from 'moment-timezone';
import { AcademyRiseAssessment } from './academy-rise-assessment';

export class UserRiseAssessment {
	public completedDate: Date;
	public details: string;
	public academyRiseAssessment: AcademyRiseAssessment;

	// internal
	public assessmentDetails: {
		userId: string;
		learnerName: string;
		courseID: string;
		lessonID: string;
		passingScore: number;
		scorePercent: number;
		responses: { number: number; question: string; isCorrect: string; correctAnswer: string; selected: string }[];
	};

	constructor(data: UserRiseAssessment) {
		Object.assign(this, data);

		this.assessmentDetails = data.details ? JSON.parse(data.details) : null;
		this.completedDate = this.completedDate ? new Date(moment(this.completedDate).format('MMM DD, YYYY hh:mm:ss a')) : this.completedDate;
	}

	get isPassed() {
		return this.assessmentDetails && this.assessmentDetails.scorePercent >= this.assessmentDetails.passingScore;
	}
}
